/**
 * Helper functions for recipe detail value validation and cleaning
 */

import { ProductPriceUtil } from '@product-detail/utils/product-price.util';
import { Product } from '@shared/models/product.model';
import { Customer } from '@usf/customer-types';
import { INGREDIENT_OPTIONS, IngredientSearchResult } from '@usf/ngrx-tools';
import { ProductSummary, Typeahead } from '@usf/product-types';

export const cleanYieldValue = (value: any): number | undefined => {
  if (Number.isNaN(Number(value)) || Number(value) <= 0) {
    return undefined;
  }

  let cleanValue = Number(value?.replace(/[^\d.]/g, '') || '');
  cleanValue = Number(cleanValue.toFixed(2));

  if (cleanValue > 9999999.99) {
    return 9999999.99;
  }

  return Number.isNaN(cleanValue) ? undefined : cleanValue;
};

export const cleanServingValue = (value: any): number | undefined => {
  if (Number.isNaN(Number(value)) || Number(value) <= 0) {
    return undefined;
  }

  let cleanValue = Number(value?.replace(/[^\d.]/g, '') || '');
  cleanValue = Number(cleanValue.toFixed(2));

  if (cleanValue > 99999.99) {
    return 99999.99;
  }

  return Number.isNaN(cleanValue) ? undefined : cleanValue;
};

export const cleanServingPerRecipeValue = (value: any): number => {
  if (Number.isNaN(Number(value)) || Number(value) <= 0) {
    return 1;
  }

  let cleanValue = Number(value?.replace(/\D/g, '') || '');

  if (cleanValue > 9999) {
    return 9999;
  }

  return Number.isNaN(cleanValue) ? 1 : cleanValue;
};

export const cleanRecipeNameValue = (value: any): string => {
  return value;
};

export const cleanRecipeDescription = (value: any): string => {
  return value;
};

export const transformProductToIngredient = (
  product: Product,
  selectedCustomer: Customer,
  id: string,
  prodName: string,
  typeAheadData?: Typeahead,
) => {
  const pricePerPortion = ProductPriceUtil.calculateCostBreakdown(
    product?.summary,
    selectedCustomer,
    product?.pricing,
    product?.summary?.standardComparisonUOM,
    product?.summary?.standardComparisonValue,
  );
  return {
    id: id,
    name: prodName,
    types: INGREDIENT_OPTIONS.PRODUCT,
    typeAheadData: typeAheadData,
    product,
    brand: product?.summary?.brand,
    price: product?.pricing?.unitPrice,
    priceUOM: product?.pricing?.priceUom,
    pricePerPortion: pricePerPortion,
    salesPackSize: product?.summary?.salesPackSize,
    pills: product?.productTags,
  } as IngredientSearchResult;
};
